import React from 'react'
import PropTypes from 'prop-types'
import { List, TextareaItem, Button, InputItem, NavBar, Checkbox, Icon, WhiteSpace, Picker, Toast, DatePicker,WingBlank,Steps } from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import { Link } from 'react-router-dom'
import { createForm } from 'rc-form'
import { postRequest } from '../../../utils/utils'
import './index.css'
import moment from 'moment'
import CustomerSearch from '../../components/customer_search'
const Item = List.Item;
const Step = Steps.Step;
const types = [
        {
            label: '内部考勤',
            value: 2,
        },
        {
            label: '外出考勤',
            value: 1,
        },
    ]

class XuJiaCheck extends React.Component {
  static propTypes = {
    form:PropTypes.object.isRequired,
      checkXuJia:PropTypes.func.isRequired
  }

  state = {
      data:{},
      option:'',
      status:'',
      out_time:'',//出门时间
      checkers:[],
      showbtn:true,
      xujia_id:'',
  };

  componentDidMount() {
    this.getDetail();
    this.getChecks();
  }
    getDetail = async() => {
        const xujia_id = localStorage.getItem('xujia_id');
        this.setState({xujia_id:xujia_id})
        postRequest(`/xujia/checkview`, `id=${xujia_id}`).then((result) => {
            console.log(result)
            if(result && result.status === 1) {
                this.setState({data:result.data})
            } else {
                Toast.fail(result.msg || '获取失败', 1);
                if(result.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            }
        })
    }
    //获取主管
    getChecks = async() => {
        postRequest(`/yijiao/zhuguan`, ``).then((result) => {
            //console.log(result)
            if(result && result.status === 1) {
                this.setState({checkers:result.data})
            }
        })
    }
    //移交保存
    YiJiao = async(checkerid) => {
        const buka_id = localStorage.getItem('waichu_id');
        let body2=`id=${buka_id}&mokuai=out`;
        //获取移交前的数据
        postRequest(`/yijiao/yj`, body2).then((result) => {
            if(result && result.status === 1) {
                const shijian=result.data.shijian
                let body=`check_id=${checkerid}&id=${buka_id}&mokuai=out&shijian=${shijian}`;
                postRequest(`/yijiao/save`, body).then((result) => {
                    //console.log(result)
                    if(result && result.status === 1) {
                        Toast.success('移交成功',1);
                    }
                })
            }
        })
    }

    agree = (status) => {

        const {history, checkXuJia } = this.props
        let body =`id=${this.state.xujia_id}&status=${status}&content=${this.state.option}`
        if(status==2){
            if(this.state.option) {
            } else {
                Toast.info('审核不通过时，必须填写理由', 1);
                this.setState({showbtn:true})
                return
            }
        }
        //console.log(body);
        checkXuJia(body, history)
  }

    render() {
        const { data,checkers,showbtn } = this.state;
        const user = JSON.parse(localStorage.getItem('daka_user'))
        const u_id = user.u_id;
        //console.log(data);
        let checkername = [];
        checkername = checkers.map((value, index) => {
            return {
                value: value.u_id,
                label: value.u_fullname
            }
        });
        //console.log(data);
        return (
            <div style={{backgroundColor:'#f5f5f7', minHeight:document.documentElement.clientHeight }}>
                <NavBar
                    mode="dark"
                    icon={<Icon type="left" />}
                    onLeftClick={() => this.props.history.goBack() }
                >续假审核</NavBar>
                <List className="my-list detail_list" renderHeader=''>
                    <Item multipleLine wrap extra={data.user_id}>申请人</Item>
                    <Item multipleLine wrap extra={data.starttime}>开始时间</Item>
                    <Item multipleLine wrap extra={data.endtime}>原结束时间</Item>
                    <Item multipleLine wrap extra={data.jieshutime}>续假时间</Item>
                    <Item multipleLine wrap extra={data.content}>续假事由</Item>
                </List>
                {u_id==data.check_name_id?
                    <List renderHeader='' className="qj-list">
                        <TextareaItem
                            value={this.state.option}
                            onChange={value=>this.setState({option:value})}
                            placeholder="请填写意见"
                            data-seed="logId"
                            rows={4}
                            ref={el => this.customFocusInst = el}
                        />
                    </List>:''}
                {data.record == '' ? '' :
                    <List renderHeader={() => '审核流程'} className="my-list">
                        <Steps className='check_step' size="small" current={5}>
                            {data.record == null ? '' :
                                data.record.map(i => (i.check_id == null ? '' :
                                        <Step key={i.id} status={i.status == 2 ? 'error' : 'process'}
                                              title=
                                                  {<div className='check_user'>
                                                      <span>{i.check_id}</span>
                                                      <span className='check_time'>{i.reply_time}</span>
                                                  </div>}
                                              description={<div><span
                                                  className='check_status'>{i.status == 2 ? '审核未通过' : '审核通过'}</span>
                                                  {i.content == '' ? '' : <span>({i.content})</span>}</div>}
                                        />
                                ))
                            }
                        </Steps>
                    </List>
                }
                <div style={{height:'40px'}}></div>

                {data.status==1||data.status==2?'':
                    !showbtn?'':
                        u_id==data.check_name_id?
                        <div className='bottom_btn'>
                            {((data.length>=22.5&&data.status==5) || data.status==4) ? '' :
                                <div className='bottom_left' onClick={()=>{this.setState({showbtn:false});this.agree(2)}}>不同意</div>
                            }
                            {data.length >= 22.5?  //大于3天有二级审核，否则一级审核
                                data.status==4 ? <div className='bottom_right' onClick={()=>{this.setState({showbtn:false});this.agree(5)}}>登记</div> :
                                    (data.status == 5 ?
                                            <div className='bottom_right' onClick={()=>{this.setState({showbtn:false});this.agree(1)}}>销假</div>:
                                            <div className='bottom_right' onClick={()=>{this.setState({showbtn:false});this.agree(1)}}>同意</div>
                                    )
                                :
                                <div className='bottom_right' onClick={()=>{this.setState({showbtn:false});this.agree(1)}}>同意</div>
                            }
                            <Picker
                                data={checkername}
                                extra="移交主管"
                                value={this.state.checkerID}
                                cols={1}
                                onOk={(v)=>{this.YiJiao(v)}}
                            >
                                <div className='bottom_right'>移交</div>
                            </Picker>
                        </div>:''
                }
            </div>
        )
    }
}

export default createForm()(XuJiaCheck)